import type {
  TemplateWithButton,
  TemplateWithButtonFrame,
} from 'hb-builder/components/BuilderComponents/block/Strips/types/items';
import type {
  ComponentSettingsTab,
  OnChangeSetting,
} from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { StripItemChildAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/stripsItemAttributes';

export type Element = 'frame' | 'headline' | 'subline' | 'button';

export type Elements = {
  identifier: Element;
  item: StyleChildProps['item'];
  label: string;
}[];

export interface FieldDisplaySelectProps {
  identifier: Element;
  isLast: boolean;
  item: StyleChildProps['item'];
  label: string;
  onChange: StyleChildProps['onChange'];
}

export interface FieldsDrawerProps<T = TemplateWithButtonFrame['children']> {
  canHideImage?: boolean;
  item: T;
  onChange: FieldDisplaySelectProps['onChange'];
}

export interface ContentItemProps<T = TemplateWithButton> {
  componentName: string;
  item: T;
  onChange: StyleChildProps['onChange'];
  parentItem: StyleChildProps['parentItem'];
  removeItemOpen: (id: string) => void;
}

export interface AddFrameButtonProps {
  getChildrenLength: () => number;
  item?: DocumentItem<StripItemChildAttributes>;
  type?: string;
}

export interface StyleChildProps
  extends Omit<ComponentSettingsTab, 'onChange' | 'defaultAttributes'> {
  frames?: TemplateWithButtonFrame[];
  handleBulkChange: OnChangeSetting;
  onChange: OnChangeSetting;
  parentItem: DocumentItem;
}

export enum BUTTON_COLOR_MODE {
  SAME = 'same',
  DIFFERENT = 'different',
}
